import React from 'react'
import Form from './Form'
import { Breadcrumb, SimpleCard } from 'app/components'
import { Box, styled } from '@mui/system'

const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const AddCompany = () => {
    return (
        <Container>
            <div className="breadcrumb">
                <Breadcrumb
                    routeSegments={[
                        {
                            name: 'Comapny Users',
                            path: '/admin/company-users/all',
                        },
                        { name: 'Form' },
                    ]}
                />
            </div>
            <SimpleCard title="Add Company User">
                <Form />
            </SimpleCard>
            <Box py="12px" />
        </Container>
    )
}

export default AddCompany
